import { INSPIRATIONAL_TEMPLATE_MAP as EN_MAP } from './i18n/inspirationalTemplateMap.en';
import { INSPIRATIONAL_TEMPLATE_MAP as ES_MAP } from './i18n/inspirationalTemplateMap.es';
import { INSPIRATIONAL_TEMPLATE_MAP as FR_MAP } from './i18n/inspirationalTemplateMap.fr';
import { INSPIRATIONAL_TEMPLATE_MAP as DE_MAP } from './i18n/inspirationalTemplateMap.de';
import { INSPIRATIONAL_TEMPLATE_MAP as JA_MAP } from './i18n/inspirationalTemplateMap.ja';
import { INSPIRATIONAL_TEMPLATE_MAP as PT_MAP } from './i18n/inspirationalTemplateMap.pt';
import { AdditionalFields } from './domain/entities/inspirationalTemplate';

export const DEFAULT_STUDIO_CATEGORY_SLUG = 'all-templates';
export const DESIGNED_TEMPLATES_CATEGORY_SLUG = 'designed-templates';
export const BLANK_TEMPLATE_META_SITE_ID =
  'fe86a14e-ef67-49b4-a409-d086f3abaa1a';
export const EDIT_TEMPLATE_URL = 'https://editor.wix.com/edit-template/from';
export const SITELESS_EDIT_TEMPLATE_URL =
  'https://editor.wix.com/edit-template/from-intro-siteless';
export const SOCIAL_MEDIA_THUMBNAIL_URL =
  'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/social-media/wix_studio_social_thumbnail_1200X628.jpg';
export const SUPPORTED_LANGUAGES = [
  'en',
  'es',
  'fr',
  'de',
  'ja',
  'pt',
] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];
export const isSupportedLanguage = (lang: string): lang is SupportedLanguage =>
  SUPPORTED_LANGUAGES.includes(lang as SupportedLanguage);

export const INSPIRATIONAL_CATEGORY_SLUG = 'inspirational';

interface CategoryGroup {
  title: string;
  categorySlugs: string[];
}

export const resolveCategoryGroups = (
  addStyle = false,
  siteApps = false,
  includeInspirationalTemplates = false,
): CategoryGroup[] => {
  const categoryGroups: CategoryGroup[] = [
    {
      title: 'app.new.bucket.category',
      categorySlugs: [
        'all-templates',
        'designed-templates',
        'wireframes',
        ...(includeInspirationalTemplates ? [INSPIRATIONAL_CATEGORY_SLUG] : []),
      ],
    },
    {
      title: 'app.new.bucket.type',
      categorySlugs: [
        'ecommerce',
        'type-portfolio',
        'one-page',
        'company-site',
        'cms',
      ],
    },
    {
      title: 'app.new.bucket.industry',
      categorySlugs: ['business', 'technology', 'creative', 'fashion-beauty'],
    },
    {
      title: siteApps ? 'app.new.bucket.siteApps' : 'app.new.bucket.features',
      categorySlugs: [
        'stores',
        'bookings',
        'feature-portfolio',
        'blog',
        'events',
        'pricing-plans',
        'restaurants',
      ],
    },
  ];
  if (addStyle) {
    categoryGroups.push({
      title: 'app.new.bucket.style',
      categorySlugs: ['dark', 'minimal', 'illustrative', 'typography'],
    });
  }
  return categoryGroups;
};

export const INSPIRATIONAL_TEMPLATES_LANGUAGE_MAP: Record<
  SupportedLanguage,
  Record<string, AdditionalFields>
> = {
  de: DE_MAP,
  es: ES_MAP,
  fr: FR_MAP,
  ja: JA_MAP,
  pt: PT_MAP,
  en: EN_MAP,
};

export const getViewUrl = ({
  language,
  slug,
}: {
  language: string;
  slug: string;
}) => {
  return `https://${
    language === 'en' ? 'www' : language
  }.wix.com/website-template/view/html/${slug}`;
};
